import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {RedirectionLoaderComponent} from './components/redirection-loader/redirection-loader.component';
import {AppRoutingModule} from "./app-routing.module";
import {appInitializer} from "./app-initializer";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import {AuthService} from "./services/auth.service";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {globalErrorHandler} from "./errors/global-error-handler";

@NgModule({
  declarations: [
    AppComponent,
    RedirectionLoaderComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [
    appInitializer,
    globalErrorHandler,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AuthService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
